import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styles from './DispatchForm.module.scss';
import { FormikInput, SelectInput } from "presentation/common";
import { dispatchPlace } from 'application/globals/new-request.data';
import { useNewReportState } from "presentation/new-report/NewReportContext";

export const DispatchForm = (props) => {
  const {
    comunaInnerRef,
    regionInnerRef,
    onDispatchPlaceSelect,
    dispatchPlaceRef,
    dataState: { dispatchRegionOptions, billIssuerSelected },
  } = useNewReportState();

  const { values, setFieldValue, setFieldTouched } = props;
  const comunaData = useMemo(() => {
    return values.regionSelected?.comuna?.map((item) => ({
      ...item,
      label: item.comuna,
      value: item.comuna_uuid
    }))
  }, [values.regionSelected])

  const handleOptionChange = useCallback((name, item) => {
    setFieldValue(name, item?.value || '');
    setFieldTouched(name, true, false);
  }, [setFieldValue, setFieldTouched]);

  const onPlaceSelection = useCallback((item) => {
    onDispatchPlaceSelect(item?.value);
    handleOptionChange('place', item);
  }, [])

  const onRegionSelection = useCallback(region => {
    // reset comuna selected
    comunaInnerRef.current.clearValue();
    handleOptionChange('comuna', null);
    setFieldTouched('comuna', false, false);
    setFieldValue('regionSelected', region);
    handleOptionChange('region', region);
  }, [regionInnerRef])

  const onComunaSelection = useCallback(item => {
    setFieldValue('street', item?.calle);
    setFieldValue('number', item?.numero);
    setFieldValue('complement', item?.complemento);
    handleOptionChange('comuna', item);
    setFieldValue('comunaSelected', item);
  }, [comunaInnerRef])

  const isEnabledAddress = values.place === 'DOMICILIO' || (values.place === 'LOCAL DE COMPRA' && billIssuerSelected.label === 'OTRO');

  useEffect(() => {
    if (!values.regionSelected) return;

    const region = values.regionSelected;
    const [comuna] = region.comuna;
    // if the region have only one comuna select first item
    if (region?.comuna?.length === 1) {
      setFieldValue('comunaSelected', comuna);
      onComunaSelection({ ...comuna, value: comuna.comuna_uuid, label: comuna.comuna });
      setFieldTouched('comuna', false, false);
    }
  }, [values.regionSelected]);

  useEffect(() => {
    dispatchPlaceRef.current.setValue(dispatchPlace[1])
  }, [])

  return (
    <div>
      <span>
        <div className="my-4">
          <span className={styles.formTitle}>Datos Despacho</span>
        </div>
      </span>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4 gap-y-6">
        <FormikInput
          required
          Component={SelectInput}
          options={dispatchPlace}
          name="place"
          disabled
          label="Lugar de Despacho"
          onSelect={item => onPlaceSelection(item)}
          innerRef={dispatchPlaceRef}
        />
        <FormikInput
          required
          disabled={dispatchRegionOptions.length === 0 || values.place === undefined}
          Component={SelectInput}
          options={dispatchRegionOptions}
          name="region"
          label="Region"
          onSelect={item => onRegionSelection(item)}
          innerRef={regionInnerRef}
        />
        <FormikInput
          required
          disabled={!values.region}
          Component={SelectInput}
          options={comunaData}
          name="comuna"
          label="Comuna"
          onSelect={item => onComunaSelection(item)}
          innerRef={comunaInnerRef}
        />
        <FormikInput
          required
          name="street"
          label="Calle"
          disabled={!isEnabledAddress}
        />
        <FormikInput
          required
          name="number"
          label="N&uacute;mero"
          disabled={!isEnabledAddress}
        />
        <FormikInput
          name="complement"
          label="Complemento"
          disabled={!isEnabledAddress}
        />
      </div>
    </div>
  )
}
export default DispatchForm;
